import { render, staticRenderFns } from "./AppHeaderSearch.vue?vue&type=template&id=67775976&scoped=true"
import script from "./AppHeaderSearch.vue?vue&type=script&lang=js"
export * from "./AppHeaderSearch.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderSearch.vue?vue&type=style&index=0&id=67775976&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67775976",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PzImage: require('/drone/src/components/PzImage/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default})
